import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CollapseBlock } from '../../../../../common/index.jsx';
import { Form, Row } from 'antd';
import Col from 'antd/es/grid/col';
import FormSwitch from '../../../../../antd/form/FormSwitch/FormSwitch.jsx';
import FormDate from '../../../../../antd/form/FormDate/FormDate.jsx';
import WritersPicker from '../WritersPicker/WritersPicker.jsx';
import { useTranslation } from 'react-i18next';
import { required } from '../../../../../antd/form/FormValidation.js';
import dayjs from 'dayjs';
import FormHiddenField from '../../../../../antd/form/FormHiddenField/FormHiddenField.jsx';
import { DATETIME_FORMAT_DATETIME } from '../../../../../../utils/helpers/CommonHelper.jsx';

function SettingsBlock({
  displayTopOptions,
  dateOfCreate,
  isEdit,
  form,
  creator,
}) {
  const { t } = useTranslation();
  const [wasOnTop, setWasOnTop] = useState(false);

  useEffect(() => {
    const topToValue = form.getFieldValue('top_to');
    setWasOnTop(topToValue != null);
  }, []); // Empty dependency array ensures this runs only once on mount

  const topValue = Form.useWatch('is_top');
  const validFromValue = Form.useWatch('valid_from');

  const onIsTopSwitchChange = () => {
    if (form.getFieldValue('top_to')) {
      form.setFieldValue(
        'again_top',
        false, // Set the value of 'is_top' switch to false
      );
      form.setFieldValue(
        'valid_from',
        validFromValue ? dayjs(new Date(dateOfCreate)) : dayjs(),
      );
    }
    form.setFieldValue(
      'top_to',
      validFromValue ? dayjs(new Date(validFromValue)).add(7, 'days') : dayjs(),
    );
  };

  const onTopAgainSwitchChange = () => {
    if (form.getFieldValue('again_top')) {
      const newValidFromValue = validFromValue ? dayjs(new Date()) : dayjs();
      form.setFieldValue(
        'valid_from',
        validFromValue ? dayjs(new Date()) : dayjs(),
      );
      form.setFieldValue(
        'is_top',
        true, // Set the value of 'is_top' switch to false
      );
      form.setFieldValue('top_to', newValidFromValue.add(7, 'days'));
    } else {
      form.setFieldValue(
        'valid_from',
        validFromValue ? dayjs(new Date(dateOfCreate)) : dayjs(),
      );
      form.setFieldValue(
        'top_to',
        (validFromValue ? dayjs(new Date(dateOfCreate)) : dayjs()).add(
          7,
          'days',
        ),
      );
    }
  };


  const disabledDate = (current) => {
    if (!validFromValue) {
      return false;
    }

    // if any condition is true, date tile, will be disabled
    return (
      // if difference is higher than 7 days
      current.diff(validFromValue, 'days') > 6 ||
      // if difference is negative - top_to value is sooner than valid_from
      current.diff(validFromValue) < 0
    );
  };

  return (
    <CollapseBlock collapsible collapse title={t('Nastavenia')}>
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <FormDate
            label={t('Začiatok platnosti')}
            name={'valid_from'}
            format={DATETIME_FORMAT_DATETIME}
            rules={[required(t)]}
            showTime
          />
          {displayTopOptions ? (
            <>
              <Row gutter={[16, 0]}>
                <Col span={12}>
                  <FormSwitch
                    label={t('Zobrazovať stále navrchu')}
                    name={'is_top'}
                    onChange={onIsTopSwitchChange}
                  />
                  {topValue && (
                    <FormDate
                      label={t('Zobrazovať navrchu do')}
                      name={'top_to'}
                      format={DATETIME_FORMAT_DATETIME}
                      rules={topValue && [required(t)]}
                      disabledDate={disabledDate}
                      showTime
                    />
                  )}
                </Col>
                <Col span={12}>
                  {isEdit && wasOnTop && (
                    <FormSwitch
                      label={t('Znovu zobraziť navrchu')}
                      name={'again_top'}
                      defaultChecked={false}
                      onChange={onTopAgainSwitchChange}
                    />
                  )}
                </Col>
              </Row>
            </>
          ) : (
            <FormHiddenField name={'is_top'} />
          )}
        </Col>
        <Col span={12}>
          <WritersPicker
            writerParams={'news'}
            permission={'news-admin'}
            currentWriterName={creator}
            isCreate={!isEdit}
            formInstance={form}
          />
          {isEdit && (
            <FormDate
              label={t('Dátum zverejnenia')}
              name={'created_at'}
              format={DATETIME_FORMAT_DATETIME}
              rules={[required(t)]}
              extra={t('Dátum, ktorý sa zobrazuje pri aktualite na webe.')}
              showTime
            />
          )}
        </Col>
      </Row>
    </CollapseBlock>
  );
}

SettingsBlock.propTypes = {
  displayTopOptions: PropTypes.bool,
  dateOfCreate: PropTypes.any,
  isEdit: PropTypes.bool,
  creator: PropTypes.string,
};

export default SettingsBlock;
